const LightningIcon = () => {
    return (
        <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Discover Boost icon coin">
                <circle id="Ellipse 382" cx="14" cy="14.5" r="14" fill="#D9E9F2"/>
                <path id="Vector" d="M18.7738 13.449C19.015 13.0637 19.028 12.5779 18.8078 12.1802C18.5876 11.7825 18.1689 11.5357 17.7143 11.5357H15.8319L17.741 5.90113C17.8703 5.51955 17.8078 5.09904 17.573 4.77162C17.3382 4.44419 16.96 4.25 16.5571 4.25H12.3143C11.7438 4.25 11.2457 4.63621 11.1037 5.1887L8.78938 14.1887C8.69316 14.5629 8.7754 14.9606 9.01217 15.266C9.24893 15.5713 9.61361 15.75 10 15.75H11.7654L10.3215 22.3767C10.1922 22.9704 10.5084 23.5711 11.0711 23.8004C11.6338 24.0297 12.2799 23.8212 12.6023 23.3062L18.7738 13.449Z" fill="#F0F299" stroke="#585788" strokeWidth="2.5" strokeLinejoin="round"/>
            </g>
        </svg>
    );
};

export default LightningIcon;
